export enum ROUTE_AUTH {
  BASE = 'auth',
  REGISTER = 'register',
  LOGIN = 'login',
  THANK_YOU = 'thank-you',
  RESET_PASSWORD = 'reset-password',
}
